import React from 'react';
import { infoLinks } from '../data/links';

const LinksPage: React.FC = () => {
  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-16 px-4">
      <h2 className="text-4xl font-bold text-red-600 text-center mb-12">Links & Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 container mx-auto">
        {infoLinks.map(link => (
          <div key={link.id} className="bg-gray-900 rounded-xl shadow-lg overflow-hidden border border-gray-700">
            <img src={link.image} alt={link.label} className="w-full h-48 object-cover" />
            <div className="p-5">
              <h3 className="text-xl font-semibold text-red-500 mb-2">{link.label}</h3>
              <p className="text-gray-300 text-sm mb-4">{link.description}</p>
              <a
                href={link.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-sm text-red-400 hover:text-red-600 transition"
              >
                Visit Link →
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LinksPage;
